import { apiRequest } from '../api/client';

/** Rates ARCA knows (`vat-rates/spec.md`, "Alícuotas admitidas"); the API answers 422 `VAT_RATE_NOT_SUPPORTED` for any other. */
export const ARCA_SUPPORTED_RATES = [0, 2.5, 5, 10.5, 21, 27] as const;

/** Matches `apps/api` `StoredVatRateWithUsage` (`vat-rate.repository.ts`). */
export interface VatRate {
  id: string;
  name: string;
  rate: number;
  isActive: boolean;
  isDefault: boolean;
  billingConceptUsageCount: number;
  createdAt: string;
  updatedAt: string;
}

/** Matches `apps/api` `GET /vat-rates` (`fiscal.config`). */
export function listVatRates(): Promise<VatRate[]> {
  return apiRequest<VatRate[]>('/vat-rates');
}

/** Matches `apps/api` `VatRateOption` (`list-vat-rates.use-case.ts`). */
export interface VatRateOption {
  id: string;
  name: string;
  rate: number;
  isDefault: boolean;
}

/** Matches `apps/api` `GET /vat-rates/options` (`contract.price.manage`; active rates only). */
export function listVatRateOptions(): Promise<VatRateOption[]> {
  return apiRequest<VatRateOption[]>('/vat-rates/options');
}

export interface CreateVatRateInput {
  name: string;
  rate: number;
  isActive?: boolean;
}

/** Matches `apps/api` `POST /vat-rates`. */
export function createVatRate(input: CreateVatRateInput): Promise<VatRate> {
  return apiRequest<VatRate>('/vat-rates', { method: 'POST', body: JSON.stringify(input) });
}

/** `rate` is immutable after creation: the API's update schema is strict. */
export interface UpdateVatRateInput {
  name?: string;
  isActive?: boolean;
  isDefault?: boolean;
}

/** Matches `apps/api` `PATCH /vat-rates/:id`. */
export function updateVatRate(id: string, input: UpdateVatRateInput): Promise<VatRate> {
  return apiRequest<VatRate>(`/vat-rates/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

/** Spanish label shared by the catalog screen and the selectors: `10,5 %`. */
export function formatVatRate(rate: number): string {
  return `${String(rate).replace('.', ',')} %`;
}
